import Breadcrumbs from "@/components/Breadcrumbs"
import Navigation from "@/components/Navigation"
import cn from "@/utils/cn"
import { ComponentPropsWithoutRef } from "react"

type PageProps = {
  breadcrumbs?: { element: React.ReactNode; url?: string }[]
} & ComponentPropsWithoutRef<"div">

const Page = ({
  breadcrumbs = [],
  className,
  children,
  ...otherProps
}: PageProps) => {
  return (
    <div className={cn("flex h-full flex-col", className)} {...otherProps}>
      <div className="sticky left-0 right-0 top-0 z-10 bg-gray-50 pb-1">
        <Navigation className="shrink-0 px-8 py-4" />
        {breadcrumbs.length > 0 && (
          <Breadcrumbs
            breadcrumbs={breadcrumbs}
            className="mb-2 mt-4 shrink-0 px-8"
          />
        )}
      </div>

      <div className="mt-2 grow px-8">{children}</div>
    </div>
  )
}

export default Page
